import "./index.scss";
export var Container = function Container(_ref) {
  var children = _ref.children,
      _ref$isGridCard = _ref.isGridCard,
      isGridCard = _ref$isGridCard === void 0 ? false : _ref$isGridCard;
  var className = "container ".concat(isGridCard ? "gridTable" : "");
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
};